import React, { Fragment } from 'react'

import { usePageContext } from '~/contexts/page-context'
import useClickAway from '~/hooks/useClickAway'
import {
  getProviderNameFromId,
  getProvidersByPageId,
  getProvidersByScope,
  transformProvidersForDropdown
} from '~/utils/providers'

import { FormError } from './form-error'
import styles from './provider-dropdown.module.css'

export const ProviderDropdown = ({ currentProvider, onProviderChange, providerError, providersOverride }) => {
  const { pageId, scope } = usePageContext()
  const { ref, active, setActive } = useClickAway()

  const openDropdown = () => setActive(true)

  const providerChangeHandler = (p) => () => {
    onProviderChange(p)
    setActive(false)
  }

  const filteredProvidersByPageId = getProvidersByPageId(pageId)
  const providers = providersOverride || getProvidersByScope(filteredProvidersByPageId, scope)

  const providerOptions = transformProvidersForDropdown(providers)

  const renderProviderOptionsGroup = (providerOptionsGroup) => (
    <Fragment key={JSON.stringify(providerOptionsGroup.providers)}>
      {providerOptionsGroup.title ? (
        <li className={styles.dropdownItemHeading}>{providerOptionsGroup.title}</li>
      ) : (
        <li className={styles.dropdownItemSpacer} />
      )}
      {providerOptionsGroup.providers.map((providerOption) => renderProviderOption(providerOption))}
    </Fragment>
  )

  const renderProviderOption = (provider) => (
    <button
      key={provider.id}
      data-cypress-id='provider-dropdown-option'
      className={`${styles.dropdownItem} fs-mask`}
      onClick={providerChangeHandler(provider)}
    >
      {provider.name}
    </button>
  )

  return (
    <div ref={ref} className={styles.dropdown}>
      <button
        type='button'
        onClick={openDropdown}
        onFocus={openDropdown}
        className={`${styles.dropdownField} fs-mask`}
        data-selected={!!(currentProvider || active)}
        data-error={!!providerError}
      >
        {currentProvider ? (
          getProviderNameFromId(providers, currentProvider)
        ) : (
          <div className={styles.dropdownFieldText}>Current provider</div>
        )}

        <svg className={active ? styles.iconRotated : styles.icon} height={18} width={18}>
          <use xlinkHref='/icons.svg#icon-chevron-down_1' />
        </svg>
      </button>

      {/* Input field below used for tracking only */}
      <input data-nerd-capture id='current-provider' name='Current provider' value={currentProvider} type='hidden' />

      {active && (
        <ul className={styles.dropdownItems}>
          {providerOptions.map((providerOptionsGroup) => renderProviderOptionsGroup(providerOptionsGroup))}
        </ul>
      )}

      {providerError && <FormError text={providerError} />}
    </div>
  )
}
